/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import { Formik } from 'formik'
import Form from './form'
import fromSearchParams from './from-search-params'
import { ContextProvider, useSearchForm } from './use-search-form'
import { arrayFrom } from '../../twd/twd'

export default ({searchParams, invType}) => (
    <React.Fragment>
    <div className="vertical-offset-sm"></div>

    <div className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>
        <ContextProvider>
        <FormMain searchParams={searchParams} invType={invType} />
        </ContextProvider>
    </div>

    </React.Fragment>
)

const FormMain = ({searchParams={}, invType} = {}) => {

    const { state, onValidate, onSubmit } = useSearchForm()

    searchParams = Object.keys(searchParams).length > 0
        ? searchParams
        : (state.value.currentValues || {})
    invType = invType
        ? invType
        : arrayFrom(searchParams.holdInvType)[0]

    let values = fromSearchParams({searchParams, invType})

    return (
        <Formik
            initialValues={ values }
            onSubmit={onSubmit}
            component={Form}
            validate={onValidate}
            validateOnBlur={true}
            validateOnChange={true}
        />
    )
}


// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/search-form.js